import React, { useContext } from 'react';
import classnames from 'classnames';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import AutoSizedText from '../_partials/AutoSizedText';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';
import s from './Tier.scss';
const TierFullView = ({ deviation, width, height })=>{
    const isMobile = useContext(MobileContext);
    const { isFullscreen, isTheater } = useDeviationViewContext();
    const style = isTheater || isFullscreen || isMobile ? {
        width,
        height
    } : {
        width
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isFullscreen && s['fullscreen']),
        style: style
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-wrap']
    }, /*#__PURE__*/ React.createElement(AutoSizedText, {
        className: s['title'],
        tooBigClassName: s['better-fit'],
        maxHeight: 180
    }, getDeviationTitle(deviation))), isFullscreen && /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation,
        withArtist: false
    })));
};
TierFullView.displayName = 'TierFullView';
export default TierFullView;
